import React from 'react';
import './Application.css';
import { useMediaQuery } from 'react-responsive';
import { Reveal } from '../common/Reveal';

export default function Application() {
    const isSmallScreen = useMediaQuery({ query: '(max-width: 768px)' });

    return (
        <>
            {
                isSmallScreen ? <div className='font-pretender'>
                    {/* livfarm greens */}
                    <Reveal as="section" className='text-livos-green lg:container' style={{ marginTop: 100 }}>
                        <div className='' style={{ marginTop: 50, marginBottom: 90, }}>
                            <object data="/assets/images/app/Mobile/app1.svg" width={'100%'} type="image/svg+xml" aria-label="app 1"></object>
                        </div>
                    </Reveal>
                    {/* livfarm greens */}
                    <Reveal as="section" className='lg:container'>
                        <div className='' style={{ marginTop: 50, marginBottom: 90, }}>
                            <object data="/assets/images/app/Mobile/app2.svg" width={'100%'} type="image/svg+xml" aria-label="app 1"></object>
                        </div>
                    </Reveal>

                    <div className='' style={{ marginBottom: 100 }}>
                        {/* image + text section */}
                        <Reveal as="section" className='text-livos-green container mb-8 pl-8 pr-8' style={{ marginTop: 100, marginBottom: 100 }}>
                            <div className='grid grid-cols-1 gap-4'>
                                <div className='pl-9 mb-8'>
                                    <object data="/assets/images/app/img3.svg" width={'100%'} type="image/svg+xml" aria-label="킹 (체스 말)"></object>
                                    {/* <img src='/assets/images/app/img3.svg' /> */}
                                </div>
                                <div className='flex items-center text-center justify-center'>
                                    <div className=''>
                                        <h3 className='font-bold text-[15px] mb-[20px] lg:mb-[30px]'>가까운 매장에 미리 주문하면<br></br>
                                            기다리지 않고 바로 픽업</h3>
                                        <p className='text-[12px] font-semibold'>
                                            복잡한 도심 속 리브팜 샐러드와 함께 즐기는<br></br>
                                            보다 건강하고 여유있는 일상의 시작</p>
                                    </div>
                                </div>
                            </div>
                        </Reveal>

                        {/* App download */}
                        <Reveal as="section" className='text-livos-green container' style={{ marginTop: 100, marginBottom: 100 }}>
                            <div className='flex justify-center'>
                                <img src='/assets/images/app/App.png' alt='app' width={80} height={80} />
                            </div>
                            <div className='text-center lg:mb-[100px] lg:mt-[100px] mb-[74px] mt-[34px]'>
                                <h3 className='lg:text-4xl md:text-3xl font-bold mb-[15px] lg:mb-[40px]'>리브팜 공식 모바일 APP</h3>
                                <p className='text-[14px]'>언제나 믿을 수 있는 신선한 한 끼를 약속합니다</p>
                            </div>
                            <div className='mb-[25px] lg:mb-[35px] flex justify-center'>
                                <a href="https://play.google.com/store/apps/details?id=com.livfarm.crm&hl=en-KR"><img src='/assets/images/app/googlestore1.svg' alt='google store' width={170} /></a>
                            </div>
                            <div className='flex justify-center'>
                                <a href='https://apps.apple.com/kr/app/%EB%A6%AC%EB%B8%8C%ED%8C%9C/id1666473311'><img src='/assets/images/app/appstore1.svg' alt='app store' width={170} /></a>
                            </div>
                        </Reveal>
                    </div>
                </div> : <>
                    <div className='font-pretendard'>
                        {/* livfarm greens */}
                        <Reveal as="section" className='text-livos-green lg:container' style={{ marginTop: 200 }}>
                            <div className='' style={{ marginTop: 50, marginBottom: 200, }}>
                                <object data='/assets/images/app/app_img.svg' aria-label='app img' width={'100%'} />
                            </div>
                        </Reveal>

                        {/* image + text section */}
                        <section className='text-livos-green container mb-8' style={{ marginTop: 200, marginBottom: 200 }}>
                            <div className='grid grid-cols-2  gap-4'>
                                <Reveal direction='right' className='flex justify-center'>
                                    <img src='/assets/images/app/img3.svg' alt='img3' />
                                </Reveal>
                                <Reveal direction='left' delay={0.15} className='flex items-center justify-center'>
                                    <div className=''>
                                        <h3 className='text-[40px] font-bold mb-[20px] lg:mb-[30px]'>가까운 매장에 미리 주문하면<br></br>
                                            기다리지 않고 바로 픽업</h3>
                                        <p className='text-[18px] lg:text-[24px] font-medium'>
                                            복잡한 도심 속 리브팜 샐러드와 함께 즐기는<br></br>
                                            보다 건강하고 여유있는 일상의 시작</p>
                                    </div>
                                </Reveal>
                            </div>
                        </section>

                        {/* App download */}
                        <Reveal as="section" className='text-livos-green container' style={{ marginTop: 200, marginBottom: 200 }}>
                            <div className='flex justify-center'>
                                <img src='/assets/images/app/App.png' alt='App' width={142} height={142} />
                            </div>
                            <div className='text-center lg:mb-[100px] lg:mt-[100px] mb-[74px] mt-[74px]'>
                                <h3 className='lg:text-[40px] md:text-[30px] font-bold mb-[15px] lg:mb-[40px]'>리브팜 공식 모바일 APP</h3>
                                <p className='lg:text-[24px] md:text-[18px] font-medium'>언제나 믿을 수 있는 신선한 한 끼를 약속합니다</p>
                            </div>
                            <div className='mb-[25px] lg:mb-[35px] flex justify-center'>
                                <a href="https://play.google.com/store/apps/details?id=com.livfarm.crm&hl=en-KR"><img src='/assets/images/app/googlestore1.svg' height={100} alt='google store' /></a>
                            </div>
                            <div className='flex justify-center'>
                                <a href='https://apps.apple.com/kr/app/%EB%A6%AC%EB%B8%8C%ED%8C%9C/id1666473311'><img src='/assets/images/app/appstore1.svg' alt='app store' /></a>
                            </div>
                        </Reveal>
                    </div>
                </>
            }
        </>
    );
}
